
import React from "react";
import AdminPanelLayout from "./AdminPanelLayout";
import DashboardMain from "./DashboardMain";

function Dashboard() {
  return (
    <AdminPanelLayout>
      <DashboardMain />
    </AdminPanelLayout>
  );
}

export default Dashboard;
